module.exports = __webpack_public_path__ + "img/card.a087f38e.png";